module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("API keys")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.siteId))])]), _vm._v(" "), _vm._l((_vm.apiKeyData), function(dataKey, index) {
    return _c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(dataKey.access) + " key:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dataKey.key))])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Shop-ID:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4351c21e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 533
// module chunks = 1